import React from 'react';
import MetadataSection from './MetadataSection';

interface MetadataPositioningSectionProps {
  children: React.ReactNode;
  dataTestId?: string;
  status?: {
    label: string;
    tone?: 'ready' | 'needed' | 'attention';
  };
}

const MetadataPositioningSection: React.FC<MetadataPositioningSectionProps> = ({ children, dataTestId, status }) => (
  <MetadataSection
    id="metadata-positioning"
    title="Reader targeting & discovery"
    description="Genres, audiences, tropes, and keywords help stores shelve and recommend your book."
    className="book-detail-workbench-section book-detail-workbench-section--divided"
    tourId="metadata-positioning"
    dataTestId={dataTestId}
    status={status}
  >
    <div className="metadata-field-grid metadata-field-grid--positioning">{children}</div>
  </MetadataSection>
);

export default MetadataPositioningSection;
